<template>
  <section class="container mx-auto flex flex-col gap-10 px-4 py-20 lg:grid lg:grid-cols-12 lg:items-center">
    <!-- Content Section - Shows First on Mobile -->
    <div class="order-1 lg:order-2 lg:col-span-7" v-scroll-reveal="{ delay: 0.15 }">
      <p class="text-sm uppercase tracking-[0.6em] text-amber-500">About Umrah Booking</p>
      <h2 class="mt-4 text-4xl font-bold text-gray-900 lg:text-5xl">
        Allah Helps Those Who Help Themselves
      </h2>
      <p class="mt-4 text-gray-600 leading-relaxed">
        For over a decade we have curated seamless Umrah journeys that balance spiritual focus with unparalleled comfort.
        Our on-ground team in Makkah and Madina secures the closest hotels, private transfers, and dedicated visa support,
        so your family can worship with complete peace of mind.
      </p>

      <div class="mt-8 grid gap-6 md:grid-cols-2">
        <div class="rounded-3xl border border-gray-100 bg-white/80 p-6 shadow-sm transition hover:-translate-y-1 hover:border-amber-200" v-scroll-reveal="{ delay: 0.2 }">
          <div class="flex items-center gap-3">
            <div class="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-600">
              <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c1.657 0 3-1.79 3-4s-1.343-4-3-4-3 1.79-3 4 1.343 4 3 4zM5 22c0-3.866 3.134-7 7-7s7 3.134 7 7" />
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-gray-900">Our Vision</h3>
          </div>
          <p class="mt-3 text-sm text-gray-600">
            Elevate every pilgrim’s experience through thoughtful itineraries, heritage-inspired hospitality, and sincere service.
          </p>
        </div>

        <div class="rounded-3xl border border-gray-100 bg-white/80 p-6 shadow-sm transition hover:-translate-y-1 hover:border-amber-200" v-scroll-reveal="{ delay: 0.35 }">
          <div class="flex items-center gap-3">
            <div class="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-600">
              <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 8l4 4-4 4M9 12h10" />
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-gray-900">Our Mission</h3>
          </div>
          <p class="mt-3 text-sm text-gray-600">
            Provide transparent pricing, 24/7 concierge care, and the freedom to customize hotels, flights, and transport for every family.
          </p>
        </div>
      </div>
    </div>

    <!-- Images Section - Shows Second on Mobile -->
    <div class="order-2 lg:order-1 space-y-4 lg:col-span-5">
      <div class="overflow-hidden rounded-[40px]" v-scroll-reveal="{ delay: 0.1 }">
        <img
          :src="image1"
          alt="Umrah scenic"
          class="h-[320px] w-full object-cover transition duration-500 hover:scale-105"
        />
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div class="overflow-hidden rounded-[32px]" v-scroll-reveal="{ delay: 0.2 }">
          <img
            :src="image2"
            alt="Masjid view"
            class="h-[220px] w-full object-cover transition duration-500 hover:scale-105"
          />
        </div>
        <div class="overflow-hidden rounded-[32px]" v-scroll-reveal="{ delay: 0.3 }">
          <img
            :src="image3"
            alt="Pilgrims"
            class="h-[220px] w-full object-cover transition duration-500 hover:scale-105"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import image1 from '../../assets/images/makkah/kaaba-kiswa-closeup.webp'
import image2 from '../../assets/images/madina/madina-daytime-crowd.jpg'
const image3 = 'https://images.unsplash.com/photo-1580418827493-f2b22c0a76cb?w=800&q=80'
export default {
  name: 'AboutSection',
  data() {
    return {
      image1: image1,
      image2: image2,
      image3: image3
    }
  }
}
</script>

